import React from "react";
import ProductCard from "./ProductCard";
import { motion } from "framer-motion";
import { Link } from "lucide-react";

const TrendingProducts = ({ products, addToCart, addedItems, categories }) => {
  return (
    <section className="container my-5 py-4">
      <div className="section_header mb-5">
        <div className="d-flex align-items-center justify-content-between">
          <div className="title-area">
            <h2 className="h3 fw-800 mb-1" style={{ color: "#1a1a1a", fontWeight: 800 }}>
              Trending Now
            </h2>
            <p className="text-muted small mb-0">Discover our most popular picks this week</p>
          </div>
          <div className="header-line flex-grow-1 mx-4 d-none d-md-block" style={{ height: '1px', background: '#eee' }}></div>
        
        </div>
      </div>

      <div className="row g-4">
        {products && products.length > 0 ? (
          products.slice(0, 8).map((item, index) => (
            <motion.div
              key={item._id}
              className="col-6 col-sm-6 col-md-4 col-lg-3"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <ProductCard
                item={item}
                categories={categories}
                addToCart={addToCart}
                isAdded={addedItems.includes(item._id)}
              />
            </motion.div>
          ))
        ) : (
          <div className="col-12 text-center py-5">
            <p className="text-muted">No products available at the moment.</p>
          </div>
        )}
      </div>
    </section>
  );
};

export default TrendingProducts;

